export default __webpack_public_path__ + "static/media/5.e4ebb630.webp";